import { styled } from "@linaria/react";

export const LoadingPageStyle = {
  LoadingPage: styled.div`
    width: 100%;
    min-height: calc(90vh - 77px - 5rem);
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};
